(function () {
  var API_URL = 'https://api.kemimoto.com/api/us/admin/getProduct';
  var MODAL_ID = 'desc-product-popup-modal';

  function extractNumericId(gidOrId) {
    if (!gidOrId) return '';
    var raw = String(gidOrId);
    return raw.indexOf('/') > -1 ? raw.split('/').pop() : raw;
  }

  function extractImageUrl(image) {
    if (!image) return '';
    if (typeof image === 'string') return image;
    return image.src || image.url || '';
  }

  function extractVariantOptionValues(variantTitle) {
    if (!variantTitle || variantTitle === 'Default Title') return [];
    return variantTitle.split(' / ').map(function (s) { return s.trim(); });
  }

  function ensureBaseDom() {
    

    if (!document.getElementById(MODAL_ID)) {
      var mask = document.createElement('div');
      mask.id = MODAL_ID;
      mask.className = 'desc-popup-mask';
      mask.innerHTML = [
        '<div class="desc-popup" role="dialog" aria-modal="true">',
        '  <button class="desc-popup-close" aria-label="Close"><span class="fa-solid fa-close"></span></button>',
        '  <div class="desc-popup-body">',
        '    <div class="desc-carousel">',
        '      <div class="desc-carousel-placeholder" aria-hidden="true"></div>',
        '      <button class="desc-carousel-nav desc-carousel-prev" type="button">&#10094;</button>',
        '      <button class="desc-carousel-nav desc-carousel-next" type="button">&#10095;</button>',
        '    </div>',
        '    <div class="desc-carousel-dots"></div>',
        '    <div class="desc-popup-content">',
        '      <h2 class="desc-popup-title"></h2>',
        '      <div class="desc-popup-price">',
        '        <span class="desc-popup-sale"></span>',
        '        <span class="desc-popup-compare"></span>',
        '      </div>',
        '      <div class="desc-variant-wrap"></div>',
        '    </div>',
        '  </div>',
        '  <div class="desc-popup-footer">',
        '    <button class="desc-popup-add" type="button">ADD TO CART</button>',
        '    <div class="desc-popup-msg"></div>',
        '  </div>',
        '</div>'
      ].join('');
      document.body.appendChild(mask);

      mask.addEventListener('click', function (e) {
        if (e.target === mask || e.target.classList.contains('desc-popup-close')) closeModal();
      });
      var closeBtn = mask.querySelector('.desc-popup-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          closeModal();
        });
      }
    }
  }

  function openModal() {
    var mask = document.getElementById(MODAL_ID);
    if (mask) mask.style.display = 'flex';
  }

  function closeModal() {
    var mask = document.getElementById(MODAL_ID);
    if (mask) mask.style.display = 'none';
  }

  function resetCarouselToPlaceholder() {
    var root = document.getElementById(MODAL_ID);
    if (!root) return;
    var container = root.querySelector('.desc-carousel');
    var prev = root.querySelector('.desc-carousel-prev');
    var next = root.querySelector('.desc-carousel-next');
    var dots = root.querySelector('.desc-carousel-dots');
    if (!container) return;

    container.classList.add('is-loading');
    container.querySelectorAll('.desc-carousel-track').forEach(function (el) { el.remove(); });
    container.querySelectorAll('.desc-carousel-img').forEach(function (el) { el.remove(); });
    container.querySelectorAll('.desc-carousel-placeholder').forEach(function (el) { el.remove(); });

    var placeholder = document.createElement('div');
    placeholder.className = 'desc-carousel-placeholder';

    if (prev) container.insertBefore(placeholder, prev);
    else if (next) container.insertBefore(placeholder, next);
    else container.appendChild(placeholder);

    if (dots) {
      dots.innerHTML = '';
      dots.style.display = 'none';
    }
  }

  async function fetchProduct(productId) {
    var response = await fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: productId })
    });
    var result = await response.json();
    if (!result || !result.data) throw new Error((result && result.message) || 'Product not found');
    return result.data;
  }

  function renderVariantButtons(product, onVariantChange) {
    var wrap = document.querySelector('#' + MODAL_ID + ' .desc-variant-wrap');
    wrap.innerHTML = '';

    var options = Array.isArray(product.options) ? product.options : [];
    var variants = Array.isArray(product.variants) ? product.variants : [];
    var hasRealOptions = options.length > 0 && !(options.length === 1 && options[0].name === 'Title');

    if (!hasRealOptions || variants.length <= 1) {
      onVariantChange(variants[0] || null);
      return;
    }

    var selected = {};
    options.forEach(function (opt) {
      selected[opt.name] = (opt.values && opt.values[0]) || '';

      var name = document.createElement('div');
      name.className = 'desc-option-name';
      name.textContent = (opt.name || 'Option').toUpperCase();
      wrap.appendChild(name);

      var grid = document.createElement('div');
      grid.className = 'desc-option-grid';

      (opt.values || []).forEach(function (val) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'desc-option-btn';
        btn.setAttribute('data-option-name', opt.name || '');
        btn.setAttribute('data-option-value', val);
        btn.textContent = val;
        btn.addEventListener('click', function () {
          selected[opt.name] = val;
          refreshButtons();
          resolveVariant();
        });
        grid.appendChild(btn);
      });

      wrap.appendChild(grid);
    });

    function refreshButtons() {
      wrap.querySelectorAll('.desc-option-btn').forEach(function (btn) {
        var n = btn.getAttribute('data-option-name');
        var v = btn.getAttribute('data-option-value');
        btn.classList.toggle('active', selected[n] === v);
      });
    }

    function resolveVariant() {
      var matched = variants.find(function (v) {
        var vals = extractVariantOptionValues(v.title);
        if (vals.length !== options.length) return false;
        for (var i = 0; i < options.length; i++) {
          var optName = options[i].name;
          if (selected[optName] !== vals[i]) return false;
        }
        return true;
      }) || variants[0] || null;

      onVariantChange(matched);
    }

    refreshButtons();
    resolveVariant();
  }

  function renderCarousel(images) {
    var safeImages = images.length ? images : [''];
    var root = document.getElementById(MODAL_ID);
    var container = root.querySelector('.desc-carousel');
    var prev = root.querySelector('.desc-carousel-prev');
    var next = root.querySelector('.desc-carousel-next');
    var dots = root.querySelector('.desc-carousel-dots');
    var idx = 0;
    var startX = 0;
    var deltaX = 0;
    var isDragging = false;
    var track = null;

    function preloadImages(urls) {
      return Promise.all(urls.map(function (url) {
        return new Promise(function (resolve) {
          if (!url) return resolve('');
          var img = new Image();
          img.onload = function () { resolve(url); };
          img.onerror = function () { resolve(url); };
          img.src = url;
        });
      }));
    }

    function clamp(n, min, max) {
      return Math.min(max, Math.max(min, n));
    }

    function updateDots() {
      if (!dots) return;
      var items = dots.querySelectorAll('.desc-carousel-dot');
      items.forEach(function (d, i) {
        d.classList.toggle('active', i === idx);
      });
    }

    function setTrackTransform(withTransition) {
      if (!track) return;
      var slideWidth = container.clientWidth || 0;
      track.style.transition = withTransition ? 'transform 260ms ease' : 'none';
      track.style.transform = 'translate3d(' + (-idx * slideWidth) + 'px,0,0)';
      updateDots();
    }

    function buildSlider(urls) {
      container.querySelectorAll('.desc-carousel-track').forEach(function (el) { el.remove(); });
      Array.prototype.forEach.call(container.children, function (child) {
        if (!child.classList) return;
        if (child.classList.contains('desc-carousel-img') || child.classList.contains('desc-carousel-placeholder')) {
          child.remove();
        }
      });

      track = document.createElement('div');
      track.className = 'desc-carousel-track';
      track.style.display = 'flex';
      track.style.width = (urls.length * 100) + '%';
      track.style.willChange = 'transform';

      urls.forEach(function (url) {
        var slide = document.createElement('div');
        slide.className = 'desc-carousel-slide';
        slide.style.flex = '0 0 ' + (100 / urls.length) + '%';

        var img = document.createElement('img');
        img.className = 'desc-carousel-img';
        img.alt = 'product image';
        img.src = url || '';
        slide.appendChild(img);
        track.appendChild(slide);
      });

      container.insertBefore(track, prev);
      setTrackTransform(false);

      if (dots) {
        dots.style.display = urls.length > 1 ? 'flex' : 'none';
        dots.innerHTML = '';
        urls.forEach(function (_, i) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'desc-carousel-dot' + (i === idx ? ' active' : '');
          dot.addEventListener('click', function () {
            idx = i;
            setTrackTransform(true);
          });
          dots.appendChild(dot);
        });
      }
      container.classList.remove('is-loading');
    }

    function applyDragTransform() {
      if (!track || !container.clientWidth) return;
      var base = -idx * container.clientWidth;
      track.style.transition = 'none';
      track.style.transform = 'translate3d(' + (base + deltaX) + 'px,0,0)';
    }

    function onStart(clientX) {
      if (!track || safeImages.length <= 1) return;
      isDragging = true;
      startX = clientX;
      deltaX = 0;
    }

    function isNavOrDotTarget(target) {
      if (!target || !target.closest) return false;
      return !!target.closest('.desc-carousel-nav, .desc-carousel-dot');
    }

    function onMove(clientX) {
      if (!isDragging) return;
      deltaX = clientX - startX;
      applyDragTransform();
    }

    function onEnd() {
      if (!isDragging) return;
      isDragging = false;
      var threshold = (container.clientWidth || 1) * 0.18;
      if (deltaX > threshold) idx = clamp(idx - 1, 0, safeImages.length - 1);
      else if (deltaX < -threshold) idx = clamp(idx + 1, 0, safeImages.length - 1);
      deltaX = 0;
      setTrackTransform(true);
    }

    prev.onclick = function () {
      idx = clamp(idx - 1, 0, safeImages.length - 1);
      setTrackTransform(true);
    };
    next.onclick = function () {
      idx = clamp(idx + 1, 0, safeImages.length - 1);
      setTrackTransform(true);
    };

    // Pointer events
    container.onpointerdown = function (e) {
      if (isNavOrDotTarget(e.target)) return;
      onStart(e.clientX);
      container.setPointerCapture && container.setPointerCapture(e.pointerId);
    };
    container.onpointermove = function (e) { onMove(e.clientX); };
    container.onpointerup = function () { onEnd(); };
    container.onpointercancel = function () { onEnd(); };
    container.onpointerleave = function () { if (isDragging) onEnd(); };

    // Touch fallback (mobile compatibility)
    container.ontouchstart = function (e) {
      if (isNavOrDotTarget(e.target)) return;
      if (!e.touches || !e.touches[0]) return;
      onStart(e.touches[0].clientX);
    };
    container.ontouchmove = function (e) {
      if (!isDragging || !e.touches || !e.touches[0]) return;
      onMove(e.touches[0].clientX);
    };
    container.ontouchend = function () { onEnd(); };

    // Mouse fallback
    container.onmousedown = function (e) {
      if (isNavOrDotTarget(e.target)) return;
      onStart(e.clientX);
    };
    window.addEventListener('mousemove', function (e) { onMove(e.clientX); });
    window.addEventListener('mouseup', function () { onEnd(); });

    container.classList.add('is-loading');
    preloadImages(safeImages).then(function (loaded) {
      idx = 0;
      buildSlider(loaded);
    }).catch(function () {
      container.classList.remove('is-loading');
    });

    window.addEventListener('resize', function () {
      if (!track) return;
      setTrackTransform(false);
    });
  }

  function renderModal(product) {
    var root = document.getElementById(MODAL_ID);
    var titleEl = root.querySelector('.desc-popup-title');
    var saleEl = root.querySelector('.desc-popup-sale');
    var compareEl = root.querySelector('.desc-popup-compare');
    var addBtn = root.querySelector('.desc-popup-add');
    var msgEl = root.querySelector('.desc-popup-msg');

    titleEl.textContent = product.title || '';

    var variants = Array.isArray(product.variants) ? product.variants : [];
    var currentVariant = variants[0] || null;

    var imageUrls = (Array.isArray(product.images) ? product.images : []).map(extractImageUrl).filter(Boolean);
    if (!imageUrls.length) imageUrls.push('');
    renderCarousel(imageUrls);

    function paintPrice() {
      if (!currentVariant) {
        saleEl.textContent = '$0.00';
        compareEl.textContent = '';
        return;
      }
      saleEl.textContent = '$' + (currentVariant.price != null ? currentVariant.price : '0.00');
      compareEl.textContent = currentVariant.compareAtPrice ? ('$' + currentVariant.compareAtPrice) : '';
    }

    renderVariantButtons(product, function (variant) {
      currentVariant = variant;
      paintPrice();
    });

    paintPrice();
    msgEl.textContent = '';

    addBtn.onclick = async function () {
      if (!currentVariant) return;
      var variantId = extractNumericId(currentVariant.id);
      if (!variantId) {
        msgEl.textContent = 'Variant ID not found';
        return;
      }
      addBtn.disabled = true;
      msgEl.textContent = 'Adding...';
      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        if (!res.ok) throw new Error('Add to cart failed');
        msgEl.textContent = 'Added to cart';
      } catch (err) {
        msgEl.textContent = err.message || 'Add to cart failed';
      } finally {
        addBtn.disabled = false;
      }
    };
  }

  async function onAddToCartClick(btn) {
    var directVariantId = extractNumericId(btn.getAttribute('data-variants-current-id') || '');
    if (directVariantId) {
      var oldText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding...';
      try {
        var quickRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: directVariantId, quantity: 1 })
        });
        if (!quickRes.ok) throw new Error('Add to cart failed');
        btn.textContent = 'Added';
      } catch (err) {
        btn.textContent = 'Failed';
      } finally {
        setTimeout(function () {
          btn.disabled = false;
          btn.textContent = oldText;
        }, 1000);
      }
      return;
    }

    var rawId = btn.getAttribute('data-product-id') || '';
    var id = extractNumericId(rawId);
    if (!id) return;

    ensureBaseDom();
    resetCarouselToPlaceholder();
    openModal();

    var msgEl = document.querySelector('#' + MODAL_ID + ' .desc-popup-msg');
    if (msgEl) msgEl.textContent = 'Loading...';

    try {
      var product = await fetchProduct(id);
      renderModal(product);
    } catch (err) {
      if (msgEl) msgEl.textContent = err.message || 'Load product failed';
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.desc-add-to-cart-btn');
    if (!btn) return;
    e.preventDefault();
    onAddToCartClick(btn);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });
})();
